import {
  Box,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Heading,
  HStack,
  SimpleGrid,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import { HiOutlinePlus, HiOutlineTrash } from "react-icons/hi";
import CodesetSelect from "../../CodesetSelect";
import UuidPreview from "../../UuidPreview";
import RateAmountInput from "../../RateAmountInput";
import { createEmptyClass } from "../../utils/placementDefaults";

const PeriodClassesEditor = ({ classes = [], onChange }) => {
  const updateClass = (classIndex, field, value) => {
    const updated = [...classes];
    updated[classIndex] = {
      ...updated[classIndex],
      [field]: value,
    };
    onChange(updated);
  };

  const addClass = () => {
    onChange([...classes, createEmptyClass()]);
  };

  const removeClass = (classIndex) => {
    const updated = [...classes];
    updated.splice(classIndex, 1);
    onChange(updated);
  };

  return (
    <Box>
      <HStack alignItems="center" mb={4}>
        <Heading size="md">Classes</Heading>
        <IconButton
          icon={<HiOutlinePlus />}
          size="md"
          aria-label="Add Class"
          onClick={addClass}
        />
      </HStack>

      <Table variant="simple" size="sm">
        <Thead>
          <Tr>
            <Th>ID</Th>
            <Th>Code</Th>
            <Th>Description</Th>
            <Th>Agency Code</Th>
            <Th>Allocation %</Th>
            <Th>Rule Code</Th>
            <Th></Th>
          </Tr>
        </Thead>
        <Tbody>
          {classes.map((classItem, classIndex) => (
            <Tr key={classItem.id}>
              <Td>
                <UuidPreview uuid={classItem.id} />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={classItem.code || ""}
                  onChange={(e) => updateClass(classIndex, "code", e.target.value)}
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={classItem.description || ""}
                  onChange={(e) => updateClass(classIndex, "description", e.target.value)}
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={classItem.agencyCode || ""}
                  onChange={(e) => updateClass(classIndex, "agencyCode", e.target.value)}
                />
              </Td>
              <Td>
                <RateAmountInput
                  value={classItem.allocationPercentage}
                  onChange={(value) => updateClass(classIndex, "allocationPercentage", value)}
                />
              </Td>
              <Td>
                <Input
                  size="sm"
                  value={classItem.ruleCode || ""}
                  onChange={(e) => updateClass(classIndex, "ruleCode", e.target.value)}
                />
              </Td>
              <Td>
                <IconButton
                  size="sm"
                  icon={<HiOutlineTrash />}
                  aria-label="Delete Class"
                  onClick={() => removeClass(classIndex)}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

export default PeriodClassesEditor;
